angular.module("digitalLeasing.module")
  .component("contractSignature", {
    templateUrl: "ng/components/digitalLeasing/contractSignature/contractSignature.view.html",
    bindings: {
      model: '=',
      verifyPage: '&',
      dichiarazioneRiconoscimento: '=',
      buttonModal: '&',
      snapshot: '<',
      portalRunned: '<',
      showHideNextButton: '&'
    },
    controllerAs: "ContractSignatureCtrl",
    controller: ContractSignatureController
  });

function ContractSignatureController(
  $portalService,
  $simulationService,
  $modalService,
  $financialApiService,
  $rootScope,
  $timeout,
  $location,
  $scope
) {
  var self = this;

  self.$onInit = function () {
    self.$portalService = $portalService;
    self.$rootScope = $rootScope;
    self.checkStipula = false;
    self.recallRestGetLinkPerson = false;
    getPopulationCheckListContract();
    controlPage();
    isCustomDocsArr()
    self.listFileDownload = {
      documentsCliAss: {
        visible: false
      },
      documentsCliCtr: {
        visible: false
      },
      documentsGar: {
        visible: false
      },
      documentsVen: {
        visible: false
      }


    }

    self.validationObj = {
      documentDate: {
        disabledDays: [0],
        disabledDates: [
          "01-01",
          "06-01",
          "25-04",
          "01-05",
          "02-06",
          "15-08",
          "01-11",
          "08-12",
          "25-12",
          "26-12"
        ]
      }
    }
    self.indexRiferimentoCliente = self.model.leasingData.preventivo.contatti.riferimenti.findIndex(function (element) {
      return element.id == "CLIENTE"
    })
  }

  self.infoRestGetLinkPerson = function (value) {
    self.enableArcButton = value.sendToArcEnabled;
    self.visibleArcButton = value.sendToArcVisible;
    self.digitalSignExternalOnly = value.digitalSignExternalOnly;
    self.sendToArcMessage = value.sendToArcMessage;
    self.cliRegisteredArc = value.cliRegisteredArc;
    self.dichiarazioneRiconoscimento = value.dichiarazioneRiconoscimento;
    self.stipulaFeEnabled = value.stipulaFeEnabled;
    self.checkStipula = value.checkStipula;
    self.printVisibile = value.printVisibile;

    checkEnableNexStep();
  }

  self.individualsOk = function () {
    self.individual = true;
    controlPage();
  }


  self.individualsNotOk = function () {
    self.individual = false;
    controlPage();
  }

  self.testCheckList = function (valore) {
    self.checkListDownload = !valore;
    controlPage();

  }
  self.documentiContrattoClienti = function (value) {
    self.checkDocumentiContrattoClienti = value;
    controlPage();
  }
  self.documentiAssicurativiClienti = function (value) {
    self.checkDocumentiAssicurativiClienti = value;
    controlPage();
  }
  self.documentiGarante = function (value) {
    self.checkDocumentiGarante = value;
    controlPage();
  }
  self.documentiVenditore = function (value) {
    self.checkDocumentiVenditore = value;
    controlPage();
  }


  self.isEveryFileUploaded = function (valore) {
    self.checkListUpload = valore;
    checkEnableNexStep();
    controlPage();
  }

  self.checkForContract = function (value) {
    self.checkContractSend = value;
    controlPage();
  }

  var controlPage = function () {

    if ($portalService.isAra()) {


      var test = self.individual &&
        /* !!!self.checkDocumentiContrattoClienti &&  MODIFICA TEMPORANEA RICHIESTA PER MAIL PER EVITARE DI RISCARIACRE I DOCUMENTI
        !!!self.checkDocumentiAssicurativiClienti &&  NON VIENE EFFETTUATO NESSUN CONTROLLO SE I DOCUMENTI DI DOWNLOAD SONO STATI SCARICATI TUTTI
        !!!self.checkDocumentiGarante &&
        !!!self.checkDocumentiVenditore && */
        self.checkListUpload
      self.verifyPage({
        value: test
      })

    } else {
      var test =
        /* !!!self.checkDocumentiContrattoClienti && MODIFICA TEMPORANEA RICHIESTA PER MAIL PER EVITARE DI RISCARIACRE I DOCUMENTI
        !!!self.checkDocumentiAssicurativiClienti && NON VIENE EFFETTUATO NESSUN CONTROLLO SE I DOCUMENTI DI DOWNLOAD SONO STATI SCARICATI TUTTI
        !!!self.checkDocumentiGarante &&
        !!!self.checkDocumentiVenditore && */
        self.checkListUpload
      self.verifyPage({
        value: test
      })
    }



  }

  var getPopulationCheckListContract = function () {
    self.restDownloadRunning = true;
    $simulationService.getChecklistDownloadContract(self.model.leasingData.contratto, self.model.monitor)
      .then(function (response) {
        console.log(response)
        self.listFileDownload = response;
        self.importantMex = response.message;
        self.restDownloadRunning = false;
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE"
        });
      })
      .catch(function (error) {
        console.log(error);
        self.restDownloadRunning = false;
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE"
        });
      })
  }

  self.removeToArc = function () {
    self.showLoader = true;
    $simulationService.removeContractToArc(self.model.leasingData.id)
      .then(function (response) {
        if (response.success) {
          self.model.leasingData.contratto.publishedArc = false;
          self.model.leasingData.contratto.sendToArc = false;
          self.checkForContract(false);
        }
        self.showLoader = false;
      })
      .catch(function (error) {
        console.log(error);
        self.showLoader = false;
      })
  }



  self.dichRiconoscimento = function (value) {
    self.showLoaderSendRiconoscimento = true;
    self.recallRestGetLinkPerson = false;
    if (!value) {
      $rootScope.openModalIdentificazione = false;
      $financialApiService.checkIdentificazione(self.model)
        .then(function (response) {
          self.responseCheckIdentificazione = response;
          if (response.showPopup) {
            self.dichiarazioneRiconoscimento = response;
            self.$rootScope.openModalIdentificazione = true;
            $timeout(function () {
              $modalService.openModal("dichIdentFirm-modal");
              $("#footerInstant").css("z-index", "-1");
              $('.financial-leasing__footer').css("z-index", "-1");
            }, 600)
            checkEnableNexStep();
          } else {
            if (response.success) {
              Object.assign(self.responseCheckIdentificazione, {
                'practiceId': self.model.leasingData.id
              })
              $financialApiService.saveIdentificazione(self.responseCheckIdentificazione)
                .then(function (response) {
                  self.showLoaderSendRiconoscimento = false;
                  self.dichiarazioneRiconoscimento.confirmed = true;
                  self.recallRestGetLinkPerson = true;
                  checkEnableNexStep();
                })
                .catch(function (error) {
                  console.log(error);
                  self.showLoaderSendRiconoscimento = false;
                  checkEnableNexStep();
                })
            }
            self.showLoaderSendRiconoscimento = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          self.showLoaderSendToArc = false;
          checkEnableNexStep();
        })
    } else {
      $modalService.closeModal("dichIdentFirm-modal")
      self.$rootScope.openModalIdentificazione = false;
      Object.assign(self.responseCheckIdentificazione, {
        'practiceId': self.model.leasingData.id
      })
      $financialApiService.saveIdentificazione(self.responseCheckIdentificazione)
        .then(function (response) {
          self.showLoaderSendRiconoscimento = false;
          self.dichiarazioneRiconoscimento.confirmed = true;
          self.recallRestGetLinkPerson = true;
          jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("update");
          checkEnableNexStep();
        })
        .catch(function (error) {
          console.log(error);
          self.showLoaderSendRiconoscimento = false;
          jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("update");
          checkEnableNexStep();
        })
    }
  }

  self.sendToArc = function () {
    self.showLoaderSendToArc = true;
    $simulationService.preSendArc(self.model.leasingData.id, self.model.leasingData.preventivo.firmaDigitale, self.model.leasingData.preventivo.firmaDigitaleEsterna, self.model.leasingData.preventivo.assicurazioni)
      .then(function (response) {
        if (response.success) {
          $simulationService.sendContractToArc(self.model)
            .then(function (response) {
              if (response.success) {
                self.model.leasingData.contratto.publishedArc = true;
                self.model.leasingData.contratto.sendToArc = true;
                self.checkForContract(true);
              }
              self.showLoaderSendToArc = false;
            })
            .catch(function (error) {
              console.log(error);
              self.showLoaderSendToArc = false;
              self.checkForContract(false);
            })

        } else {
          self.showLoaderSendToArc = false;
        }
      })
      .catch(function (error) {
        self.showLoaderSendToArc = false;
      })

  }

  self.closeModal = function (value) {
    if (value == 'stipulaModal') {
      $modalService.closeModal("stipula-modal");
      $("#footerInstant").css("z-index", "2");
      $('.financial-leasing__footer').css("z-index", "2");
      self.showLoaderPreStipula = false;
    } else {
      self.showLoaderSendToArc = false;
      self.$rootScope.openModalIdentificazione = false;
      self.showLoaderSendRiconoscimento = false;
      $modalService.closeModal("dichIdentFirm-modal");
      $("#footerInstant").css("z-index", "2");
      $('.financial-leasing__footer').css("z-index", "2");
    }
  }
  self.checkPerson = function () {

    var result = self.model.financialCustomer.metadata.riUserF.listaPf
      .some(function (element) {
        return element.personalDocsComplete == false
      })

    return result;
  }

  self.enabledButton = function () {

    return self.enableConfermButton &&
      !!self.model.financialCustomer.metadata.adeguataVerifica.dataRiconoscimento
  }

  self.checkEnableButton = function (value) {
    self.disabledEnabledButtonSendArc = value;
  }

  self.infoPage = function () {
    controlPage();
  }

  self.checkIfSignChanged = function () {
    self.changedSignatureMethod = !self.changedSignatureMethod;
  }

  self.aggionaListaDownload = function () {
    getPopulationCheckListContract();
  }

  var getWizardMap = function (viewIndex) {
    return $rootScope.wizardMap.find(function (element) {
      return element.index == viewIndex;
    }).viewName;
  };

  self.preStipula = function () {
    self.showLoaderPreStipula = true;
    $simulationService.preStipula(self.model.leasingData.id)
      .then(function (response) {
        if (response.success) {
          $modalService.openModal("stipula-modal");
          $("#footerInstant").css("z-index", "-1");
          $('.financial-leasing__footer').css("z-index", "-1");

        }
        self.showLoaderPreStipula = false;
      })
      .catch(function (error) {
        self.showLoaderPreStipula = false;
      })
  }

  self.setValueModal = function (campo, valore) {
    self.model.leasingData.contratto[campo] = valore;
    if (campo == 'dataIncasso') {
      if (!!self.model.leasingData.contratto.dataIncasso) {

        self.setImportoObbligatorio = true;
      } else {
        self.setImportoObbligatorio = false;
      }
    }
    if (campo == 'importoIncasso') {
      if (!!self.model.leasingData.contratto.importoIncasso) {

        self.setDataIncassoObbligatorio = true;
      } else {
        self.setDataIncassoObbligatorio = false;
      }
    }
  }

  self.stipula = function () {
    $modalService.closeModal("stipula-modal");
    $rootScope.$broadcast("pageLoader", {
      action: "OPEN",
    });
    $simulationService.stipula(self.model.leasingData.id, self.model.leasingData.contratto.dataStipula, self.model.leasingData.contratto.dataIncasso, self.model.leasingData.contratto.importoIncasso, self.model.leasingData.contratto.cro)
      .then(function (response) {
        if (response.success) {
          self.checkStipula = true;
          $rootScope.$broadcast("addAlert", {
            text: "STIPULA_SUCCES",
          })
          $location.path('/')
        }
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE",
        });
      })
      .catch(function (error) {
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE",
        });
      })
  }

  var checkEnableNexStep = function () {
    var dichiarazioneOk = (self.dichiarazioneRiconoscimento && ((self.dichiarazioneRiconoscimento.sectionVisible && self.dichiarazioneRiconoscimento.confirmed) || !self.dichiarazioneRiconoscimento.sectionVisible));
    var visible = self.checkListUpload && !self.stipulaFeEnabled && dichiarazioneOk || self.checkStipula;
    self.showHideNextButton({
      showHideButton: visible
    })
  }

  var isCustomDocsArr = function () {
    $simulationService.getCustomDocsCtr(self.model.leasingData.id)
      .then(function (response) {
        if (response.success) {
          self.docAggOpened = response.documents && !!response.documents.length
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  self.enebleButtonConfirmStipula = function () {
    var pippo = $scope.stipulaForm;
    var test = true;

    test = test && !!self.model.leasingData.contratto.dataStipula

    if (self.setImportoObbligatorio || self.setDataIncassoObbligatorio) {
      test = test &&
        !!self.model.leasingData.contratto.dataIncasso &&
        !!self.model.leasingData.contratto.importoIncasso
    }

    return test;
  }
}
